import { defineMeta } from '@/registry/types';

export const switchMeta = defineMeta({
  name: 'Switch',
  level: 'atom',
  category: 'input',
  classification: 'themed-mui',
  description: 'Instant on/off setting control. Themed MUI Switch.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Switch',
  muiDocs: 'https://mui.com/material-ui/react-switch/',
  a2uiEquivalent: 'Switch',
  importPath: '@/atoms/Switch',
  optionalProps: ['checked', 'defaultChecked', 'disabled', 'size', 'onChange'],
  supportedStates: ['on', 'off', 'disabled', 'focus'],
  designTokens: ['colors'],
  accessibility: [
    'Wrap with FormControlLabel for an accessible label.',
    'Represents an immediate state change (no Save needed).',
  ],
  usageExamples: ['<FormControlLabel control={<Switch />} label="Notifications" />'],
  antiPatterns: ['Do not use a Switch when a form submit is required to apply the change (use Checkbox).'],
  llmSafe: true,
  whenToUse: ['Toggling a setting that applies immediately'],
  whenNotToUse: ['Form fields requiring submit', 'Selecting from options'],
});

export default switchMeta;
